module.exports = __webpack_public_path__ + "assets/img/gallery@2x.70aa0b3f.jpg";